import { Box, Image, Flex, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"

import { jewlr_t } from "helpers/application"
import { to_currency } from "helpers/number"

const HowItWorks = ({ payIn4 }) => {
  const data = [
    {
      desc: `Create your favourite styles and add them to your ${jewlr_t(
        "cart"
      )}.`,
      img: "one",
      title: `Shop For ${jewlr_t("terms.Jewelry")}`,
    },
    {
      desc: `If your order is over ${to_currency(
        sl.config.klarna_min
      )} at checkout, select Klarna and provide your debit or credit card information.`,
      img: "two",
      title: "Choose Klarna",
    },
    {
      desc: `Once your order is complete, Klarna will send you an email confirmation and ${jewlr_t(
        "terms.instalment"
      )} payment notice.`,
      img: "three",
      title: "Complete Order",
    },
    {
      desc: payIn4
        ? "Your first payment is made at point of purchase; the next 3 are automatically charged every 14 days."
        : `Your first ${jewlr_t(
            "terms.instalment"
          )} is made at point of purchase; the remaining 2 are automatically charged every 30 days.`,
      img: "four",
      title: payIn4 ? "Pay Later in 4" : "Pay In 3 With Klarna",
    },
  ]
  return (
    <Box contain mb={6}>
      <Typography as="h1" fontSize={30} my={6} textAlign="center">
        How It Works
      </Typography>

      <Flex
        alignItems="center"
        flexDirection={{ _: "column", tablet: "row" }}
        ml={{ desktop: "140px", tablet: 8 }}
      >
        <Box flex="1">
          {data.map((item) => (
            <Flex
              alignItems={{ tablet: "flex-start" }}
              flexDirection={{ _: "column", tablet: "row" }}
              key={item.title}
              mb={6}
              textAlign={{ _: "center", tablet: "left" }}
            >
              <Box
                flex={{ tablet: "0 0 auto" }}
                pb={{ _: 2, tablet: 0 }}
                pr={{ tablet: 2 }}
              >
                <Image
                  alt={item.title}
                  src={require(`images/info/klarna/${item.img}.svg`)}
                  width={{ _: "44px", tablet: "32px" }}
                />
              </Box>
              <Box>
                <Typography fontSize={18} fontWeight="700" mb={1}>
                  {item.title}
                </Typography>
                <Typography pr={{ tablet: 4 }} px={{ _: 6, tablet: 0 }}>
                  {item.desc}
                </Typography>
              </Box>
            </Flex>
          ))}
        </Box>
        <Box flex="1" textAlign="left">
          <Image
            alt="How It Works"
            lazyload={false}
            src={require(
              `images/info/klarna/${sl.config.site_country}-jewlr4-how-it-works.png`
            )}
            width={{ tablet: "80%" }}
          />
        </Box>
      </Flex>
    </Box>
  )
}

HowItWorks.propTypes = {
  payIn4: PropTypes.bool,
}

export default HowItWorks
